import React from 'react';

interface SpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ message = 'Loading...', size = 'medium', className = '' }) => {
  const sizeStyles = {
    small: { width: '32px', height: '32px' },
    medium: { width: '48px', height: '48px' },
    large: { width: '64px', height: '64px' }
  };

  return (
    <div className={`spinner-container ${className}`}>
      <div className="spinner-content">
        <div className="spinner" style={sizeStyles[size]} />
        {message && <p className="spinner-message">{message}</p>}
      </div>
    </div>
  );
};

export default Spinner;
